import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

// REASON:  The reason we define a public route is so that once user is authenticated and logged in, 
// you don't want to allow them to hit public routes like Login and Signup. If they try to manually 
// enter these routes on browser, you want them to be routed to main dashboard.
//
// ABOUT THIS COMPONENT: Props are passed to this component => <PublicRoute>, from <AppRouter>. The 
// first 5 lines of code destructures the object passed in. The destructure pulls out isAuthenticated,
// component, and  {...rest}, which contains any other properties in props list. See commnents to the right
// of the 5 lines of code for more detail. The next 12 lines of code will either redirect you to dashboard
// if alraedy authenticated, or render the public component (eg. signup) if not authenticated.
// The public route is not going to allow you to hit public routes like /login and /signup as it does not 
// make sense. 

export const PublicRoute = ({
    isAuthenticated,        // this prop gets passed in from mapStateToProps; this is also used as component props below
    component: Component,   // this prop gets passed in from <PublicRoute>; note that this both destructuring and renaming component 
    ...rest                 // the rest of the props (exact and path) also get  passed in from <PublicRoute>
}) => {
    // Note that from the parent <Router>/<PublicRoute> component, this component gets passed the
    // component prop and the rest of the props, which includes 'path' and 'exact' property (if specified). 
    // The props passed into the component itself below,  are standard props that the react router passes
    // its components such as location: {pathname,search, hash, key} and computedMatch: { path,url, isExact, params}.
    return (
        <Route {...rest} component={ (props) => (
                isAuthenticated ? (
                    <Redirect to="/dashboard" />
                ) : (
                  <Component {...props} />
                )
            )
        }   />
    );
}

// Using this with my email auth provider vs google auth provider.
const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.token    // !! converts truthy or falsy value to boolean
});

// This was used with google provider
// const mapStateToProps = (state) => ({
//     isAuthenticated: !!state.auth.uid    // !! converts truthy or falsy value to boolean
// });


export default connect(mapStateToProps)(PublicRoute);

// saved version of code before adding the return statement, so I can add comment.
// export const PublicRoute = ({
//     isAuthenticated,        // this prop gets passed in from mapStateToProps; this is also used as component props below
//     component: Component,   // this prop, gets passed in from <PublicRoute>
//     ...rest                 // the rest of the props (exact and path) also get  passed in from <PublicRoute>
// }) => (
//     <Route {...rest} component={ (props) => (
//             isAuthenticated ? (
//                 <Redirect to="/dashboard" />
//             ) : (
//                 <Component {...props} />
//             )
//         )
//     }   />
// );



// WEBPACK FOOTER //
// ./src/routers/PublicRoute.js